main();

function main() {
    const name = window.sessionStorage.getItem('name');

    if (name) {
        const grab = document.querySelector('#name') as HTMLSpanElement;
        grab.innerText = ` ${name}`;
    }
}